export const ZIP_REGEX = /^\d{5}(?:[-\s]\d{4})?|[a-zA-Z]\d[a-zA-Z][\s-]?\d[a-zA-Z]\d$/;
